import { localizedStrings } from "../static/copy"

export type LocalizedStringKey = keyof typeof localizedStrings

export const getLocalizedString = (key: LocalizedStringKey): string => {
  return localizedStrings[key]
}
